import { getLatestPosts } from '$lib/blog/posts';
import { authors } from '$lib/blog/authors';

export const prerender = true;

export async function load() {
    const latestPosts = await getLatestPosts(3);
    return { latestPosts, authors };
}
